function updateSelectedRazor(clickedElement, variantName) {
    var razorQuiz = document.querySelectorAll('[data-razor-kit-quiz]');
    if (razorQuiz && window.location.pathname.includes('razor-kit')) {
        for(quiz of razorQuiz){
            quiz.setAttribute('data-selected-razor', variantName);
        }
    }

    var miniRazorQuiz = document.querySelectorAll('[data-mini-razor-quiz]');
    if (miniRazorQuiz && window.location.pathname.includes('mini-razor')) {
        for(quiz of miniRazorQuiz){
            quiz.setAttribute('data-selected-razor', variantName);
        }
    }

    var shaveStarterSet = document.querySelectorAll('[data-shave-starter-set-quiz]');
    if (shaveStarterSet && window.location.pathname.includes('perfect-shave-set')) {
        for(quiz of shaveStarterSet){
            quiz.setAttribute('data-selected-razor', variantName);
        }
    }

    var dreamRoutineQuiz = document.querySelectorAll('[data-dream-routine-quiz]');
    if (dreamRoutineQuiz && window.location.pathname.includes('dream-routine')) {
        for(quiz of dreamRoutineQuiz){
            quiz.setAttribute('data-selected-color', variantName);
        }
    }

    var whippedShaveSetQuiz = document.querySelectorAll('[data-whipped-shave-set-quiz]');
    if (whippedShaveSetQuiz && window.location.pathname.includes('whipped-shave-set')) {
        for(quiz of whippedShaveSetQuiz){
            quiz.setAttribute('data-selected-color', variantName);
        }
    }

    var shaveStarterSetQuiz = document.querySelectorAll('[data-shave-starter-set-quiz]');
    if (shaveStarterSetQuiz && window.location.pathname.includes('shave-starter-set')) {
        for(quiz of shaveStarterSetQuiz){
            quiz.setAttribute('data-selected-color', variantName);
        }
    }
}

function updateQuizVariantId(clickedElement) {
    // Get the variant ID from the clicked element's data-variant-id attribute
    var variantId = clickedElement.getAttribute('data-variant-id');
    // Also get the display value/name if available
    var variantName = clickedElement.value || clickedElement.getAttribute('value') || '';
    
    if (variantId) {
        // Find all generic quiz elements on the page
        var genericQuizzes = document.querySelectorAll('generic-quiz');
        
        if (genericQuizzes.length > 0) {
            for (var i = 0; i < genericQuizzes.length; i++) {
                // Update the data-selected-main-variant-id attribute
                genericQuizzes[i].setAttribute('data-selected-main-variant-id', variantId);
                // Also update by name so the quiz can map to its own product's variant ID
                if (variantName) {
                    genericQuizzes[i].setAttribute('data-selected-main-variant-name', variantName);
                }
            }
        }
    }
}